import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { PapiGallection } from '@wix/da-papi-types';
import { AppState } from '../../types/store';
import { getSelectedFolder, getIsDndReorderSupported } from '../../selectors/studio';
import { reorderRow } from '../../actions/studio/table';
import { Props } from './StudioDeviationGrid';

export type StateProps = Pick<Props, 'selectedFolder' | 'isDndReorderSupported'>;
export type DispatchProps = Pick<Props, 'onReorder'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  selectedFolder: getSelectedFolder(state) as PapiGallection,
  isDndReorderSupported: getIsDndReorderSupported(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onReorder: reorderRow,
};

export default connect(mapStateToProps, mapDispatchToProps);
